import Button from "../common/Button";
import Flow from "../common/Flow";
import Modal from "../common/Modal";
import Systems from "./Systems";
import Typography from "../common/Typography";

function SystemsModal({ store }) {
  return (
    <Modal store={store} $backgroundColor="primary-500">
      <Flow $space={3}>
        <Typography as="h1" fontSize="2xl">Nearby systems</Typography>
        {store.state.systems.length == 0 &&
          <Button $action onClick={() => store.shipScanSystems()}>Scan systems</Button>
        }
      </Flow>
      <Systems store={store} />
    </Modal>
  )
}

export default SystemsModal;
